import { Button } from "@mui/material";
import { Link } from "react-router";
import { ButtonStyles } from "../../styles/commonStyles";

const LinkButton = ({ label, href, icon: Icon, disabled, sx }) => {
  return (
    <Button
      variant="contained"
      startIcon={Icon}
      component={Link}
      to={href}
      sx={{ ...ButtonStyles, ...sx }}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default LinkButton;
